<template>
  <div class="login_box">
    <div class="login_contatiner">
      <div class="login_form">
        <el-form  :model="formInline" :rules="rules" ref="formInline"  class="demo-form-inline">
          <el-form-item prop="userPhone">
            <el-input v-model="formInline.userPhone" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="formInline.password" type="password"  placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width:100%;" @click="login('formInline')">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import {userLogin} from '@/api/login'
    export default {
        name: "index",
      data(){
          return{
            formInline:{},
            rules: {
              userPhoneOrName: [
                { required: true, message: '请输入用户名', trigger: 'blur' },
              ],
              password: [
                { required: true, message: '请输入密码', trigger: 'blur' },
              ],
            }
          }
      },
      mounted(){
          if(localStorage.getItem('token')!='' &&localStorage.getItem('token')!=null&&localStorage.getItem('token')!=undefined){
            this.$router.push('/statistics')
          }
      },
      methods:{
         login(formName){


          this.$refs[formName].validate(async (valid) => {

            if (valid) {
              let body={
                ...this.formInline,
                logType:0
              }
              let res = await userLogin({body})
              if (res.code=='2000'){
                window.localStorage.token=res.body.token
                this.$message.success('登录成功')
                this.$router.push('/statistics')
              }else{
                this.$message.error(res.msg)
              }

            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
      }
    }
</script>

<style scoped>
  .login_box{
    width: 100%;
    height: 100%;
    background: url("../../assets/login_bg.jpg") 0 0 no-repeat;
    position: fixed;
  }
  .login_contatiner{
    position: absolute;
    width: 1000px;
    height: 500px;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin:auto;
    background: url("../../assets/login_bg1.jpg") 0 0 no-repeat;
    background-size: 100%;
  }
  .login_form{
    position: absolute;
    width: 300px;
    height: 200px;
    right: 79px;
    top: 134px;
  }
  .copyright{
    position: fixed;
    bottom:20px;
    text-align: center;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue